import React from 'react';
import logo from './logo.svg';
import './App.css';
import Card from './Card/Card';

function App() {
  return (
    <div className="App">
      <h1>Word Guess</h1>
      <Card />
    </div>
  );
}

export default App;
